module.exports = __webpack_public_path__ + "static/abiliticbt-logo-fr-3d5f53ebc65eab1fe5808a839c66dfb3.png";